var $e83474afc7c44eea$exports = {};
$e83474afc7c44eea$exports = {
    "collapse": `Restr\xe2nge\u{21B}i`,
    "expand": `Extinde\u{21B}i`
};


export {$e83474afc7c44eea$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
